import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const FieldsetBody = styled.div`
  > * {
    margin-bottom: ${tokens.spacer.x3};
  }

  > :last-child {
    margin-bottom: 0;
  }
`;

export const FieldTitle = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  color: ${tokens.color.text_light};
  font-weight: 600;
`;

export const Address = styled.div`
  white-space: pre-line;
`;
